var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSection2A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 37,
    viewBox: "0 0 82 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 81727"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 16299",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1.95786C1 1.42885 1.42885 1 1.95786 1H5.39215V13.4048H1V1.95786Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 16300",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2C1 1.44772 1.39718 1 1.88713 1H81V36.4983H1V2Z",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3272",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44416 5.47035C8.83832 5.47035 9.15785 5.15082 9.15785 4.75666C9.15785 4.3625 8.83832 4.04297 8.44416 4.04297C8.05 4.04297 7.73047 4.3625 7.73047 4.75666C7.73047 5.15082 8.05 5.47035 8.44416 5.47035Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3273",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44416 8.26136C8.83832 8.26136 9.15785 7.94183 9.15785 7.54767C9.15785 7.15351 8.83832 6.83398 8.44416 6.83398C8.05 6.83398 7.73047 7.15351 7.73047 7.54767C7.73047 7.94183 8.05 8.26136 8.44416 8.26136Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3274",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44416 11.0514C8.83832 11.0514 9.15785 10.7319 9.15785 10.3377C9.15785 9.94355 8.83832 9.62402 8.44416 9.62402C8.05 9.62402 7.73047 9.94355 7.73047 10.3377C7.73047 10.7319 8.05 11.0514 8.44416 11.0514Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3275",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3797 5.47035C11.7739 5.47035 12.0934 5.15082 12.0934 4.75666C12.0934 4.3625 11.7739 4.04297 11.3797 4.04297C10.9855 4.04297 10.666 4.3625 10.666 4.75666C10.666 5.15082 10.9855 5.47035 11.3797 5.47035Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3276",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3797 8.26136C11.7739 8.26136 12.0934 7.94183 12.0934 7.54767C12.0934 7.15351 11.7739 6.83398 11.3797 6.83398C10.9855 6.83398 10.666 7.15351 10.666 7.54767C10.666 7.94183 10.9855 8.26136 11.3797 8.26136Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 3277",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3797 11.0514C11.7739 11.0514 12.0934 10.7319 12.0934 10.3377C12.0934 9.94355 11.7739 9.62402 11.3797 9.62402C10.9855 9.62402 10.666 9.94355 10.666 10.3377C10.666 10.7319 10.9855 11.0514 11.3797 11.0514Z",
    fill: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 16301",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.07576C1 1.5415 1.39654 1.1084 1.8857 1.1084H81V13.1084H1V2.07576Z",
    stroke: "#4E4E4E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23992",
    x: 15.4922,
    y: 3.73242,
    width: 30,
    height: 8,
    fill: "#C4C4C4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection2A);
export default __webpack_public_path__ + "static/media/Section2A.80a169a48511ee1550fe55d27ecac070.svg";
export { ForwardRef as ReactComponent };